import { LoginOutlined } from "@ant-design/icons";
import { Button } from "antd";

export default function Login({ backendUrl, state }) {
  // TODO: preserve query string (aka search params)
  const redirect_uri = `${window.location.origin}/callback`;

  return (
    <div style={{ textAlign: "center" }}>
      <h1>Waze Data Explorer</h1>
      <Button
        type="primary"
        href={`${backendUrl}/login?state=${state}&redirect_uri=${redirect_uri}`}
        icon={<LoginOutlined />}
        size="large"
        style={{ textDecoration: "none" }}
      >
        Cliquez ici pour se connecter
      </Button>
    </div>
  );
}
